<p-dialog [(visible)]="visibleBankTransferModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="closeModal()">
  <div class="dialog">
    <form class="form" [formGroup]="formBankTransfer" (ngSubmit)="onBankTransfer()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info pb-35">
            <h2>Transferencia a otros bancos</h2>
            <p>Proporciona la información de una cuenta que esté a tu nombre: <strong>{{ request?.person?.first_name }} {{ request?.person?.last_name }}</strong>.</p>
          </div>
          <div class="dialog__form">
            <div class="form__content">
              <div class="form__group mb-40" [ngClass]="{'form__error': submitted && fBankTransfer['bank_name'].errors}">
                <label class="form__label pb-5" for="name">¿En qué banco tienes tu cuenta? *</label>

                <p-dropdown [options]="country.bankList" [editable]="false" [placeholder]="'Selecciona'" id="name" optionLabel="name" optionValue="name" formControlName="bank_name"></p-dropdown>

                <span class="form__msgError" *ngIf="submitted && fBankTransfer['bank_name'].errors">
                  <small class="p-error" *ngIf="fBankTransfer['bank_name'].getError('required')">{{ 'El banco' | required}}</small>
                </span>
              </div>

              <div class="form__group mb-40" [ngClass]="{'form__error': submitted && fBankTransfer['type'].errors}">
               <label for="" class="form__label pb-20">¿Qué tipo de cuenta es? *</label>
                
                <div class="form__radio">
                  <div class="form__radioItem" *ngFor="let account of AccountType">
                    <p-radioButton [inputId]="account.value" [value]="account.value" formControlName="type" name="type"></p-radioButton>
                    <label class="small" [for]="account.value">{{ account.label }}</label>
                  </div>
                </div>

                <span class="form__msgError" *ngIf="submitted && fBankTransfer['type'].errors">
                  <small class="p-error" *ngIf="fBankTransfer['type'].getError('required')">{{ 'El tipo de cuenta' | required}}</small>
                </span>
              </div>

              <div class="form__group" [ngClass]="{'form__error': submitted && fBankTransfer['number'].errors}">
                <label class="form__label pb-5" for="number">Coloca el número de la cuenta *</label>
                
                <input pInputText type="text" id="number" formControlName="number" />

                <span class="form__msgError" *ngIf="submitted && fBankTransfer['number'].errors">
                  <small class="p-error" *ngIf="fBankTransfer['number'].getError('required')">{{ 'El número de la cuenta' | required}}</small>
                </span>
              </div>
            </div>

            <div class="form__btn pt-40">
              <button pButton pRipple type="submit" label="Transferir dinero" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" [loading]="loading"></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>